/*
 * Copyright (C) 2018 - 2026 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import { createBrowserHub } from './createBrowserHub';
import type { TabPort, WorkerPort } from './protocol';

export function createStreamPort(): TabPort {
  if (typeof SharedWorker !== 'undefined') {
    const worker = new SharedWorker(new URL('./worker/streamWorker.ts', import.meta.url), { name: 'event-stream' });
    worker.port.start();
    return worker.port as unknown as TabPort;
  }
  const { hub, managers } = createBrowserHub();
  window.addEventListener('online', () => managers.forEach((manager) => manager.handleOnline()));
  window.addEventListener('offline', () => managers.forEach((manager) => manager.handleOffline()));
  const channel = new MessageChannel();
  hub.addPort(channel.port1 as unknown as WorkerPort);
  channel.port1.start();
  channel.port2.start();
  return channel.port2 as unknown as TabPort;
}
